{
  "hash": "b638579754268729c7ccd278e28e4a478310ac95",
  "shortHash": "b63857975",
  "branch": "fable/acme",
  "tag": "v0.11.29-365-gb63857975",
  "isDirty": false,
  "buildTime": "2026-10-19T16:11:37.786Z"
}